/* unplugin-vue-components disabled */import { ElRadioGroup as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/radio-group/style/css';
import { ElRadioButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/radio-button/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0afe757a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "real-name-container"
};
const _hoisted_2 = {
  class: "tab flex justify-between marginT10"
};
const _hoisted_3 = /*#__PURE__*/_createTextVNode("实名参数");
const _hoisted_4 = /*#__PURE__*/_createTextVNode("渠道实名");
const _hoisted_5 = {
  class: "content-container"
};
import { useAppStore } from '@/store/modules/app';
import ParamsRealName from './paramsRealName.vue';
import ChannelRealName from './channelRealName.vue';
export default /*#__PURE__*/_defineComponent({
  setup(__props) {
    const currentTab = ref('params');
    const useApp = useAppStore();
    const gameInfo = computed(() => useApp.gameInfo);
    return (_ctx, _cache) => {
      const _component_el_radio_button = __unplugin_components_0;
      const _component_el_radio_group = __unplugin_components_1;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_radio_group, {
        modelValue: currentTab.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => currentTab.value = $event)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio_button, {
          label: "params"
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }), _createVNode(_component_el_radio_button, {
          label: "channel"
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_5, [currentTab.value === 'params' ? (_openBlock(), _createBlock(ParamsRealName, {
        key: 0,
        gameInfo: _unref(gameInfo)
      }, null, 8, ["gameInfo"])) : (_openBlock(), _createBlock(ChannelRealName, {
        key: 1,
        gameInfo: _unref(gameInfo)
      }, null, 8, ["gameInfo"]))])]);
    };
  }
});